import {
	mdiArchive,
	mdiAccountStar,
	mdiBookOpenPageVariant,
	mdiCalendarClock,
	mdiCertificate,
	mdiStar,
	mdiFlag,
	mdiTicketPercent,
	mdiPercent,
	mdiCurrencyUsd,
	mdiKeyVariant,
	mdiBellOutline,
	mdiDomain,
	mdiHome,
	mdiMessage,
	mdiNewspaperVariantMultipleOutline,
	mdiChartLine,
	mdiChartTimelineVariant,
	mdiClipboardCheckOutline,
	mdiMapMarkerPath,
} from '@mdi/js'

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'academy-dashboard',
	},
	{
		title: 'Catálogo',
		icon: mdiArchive,
		children: [
			{ title: 'Produtos', to: 'academy-products-list' },
			{ title: 'Moderação', to: 'academy-products-moderation' },
		],
	},
	{
		title: 'eBooks',
		icon: mdiBookOpenPageVariant,
		children: [
			{ title: 'Lista', to: 'academy-ebooks-list' },
			{ title: 'Novo eBook', to: 'academy-ebooks-new' },
		],
	},
	{
		title: 'academyProductAnalytics.menu',
		icon: mdiChartTimelineVariant,
		module: 'MGA,courses',
		to: 'academy-product-analytics',
	},
	{
		title: 'menu.academy.courses',
		icon: mdiArchive,
		module: 'MGA,courses',
		children: [
			{ title: 'menu.academy.courses', to: 'academy-courses-courses-list' },
			{ title: 'menu.academy.categories', to: 'academy-courses-categories-list' },
			{ title: 'menu.academy.subcategories', to: 'academy-courses-subcategories-list' },
			{ title: 'menu.academy.formats', to: 'academy-courses-formats-list' },
			{ title: 'menu.academy.levels', to: 'academy-courses-levels-list' },
		],
	},
	{
		title: 'academyAssessmentsTechnical',
		icon: mdiClipboardCheckOutline,
		module: 'MGA,courses',
		children: [
			{ title: 'academyStats', to: 'academy-stats' },
			{ title: 'academyAssessmentsList', to: 'academy-assessments-list' },
			{ title: 'academyAssessmentsNew', to: 'academy-assessments-new' },
			{ title: 'academyAssessmentsGenerateWithAi', to: 'academy-assessments-generate-ai' },
			{ title: 'academyAssessmentsCategoriesTitle', to: 'academy-assessment-categories-list' },
			{ title: 'academyAssessmentsCertificationsTitle', to: 'academy-assessments-certifications' },
			{ title: 'academyActivityAssessmentsTitle', to: 'academy-assessments-activity' },
		],
	},
	{
		title: 'academyCareerTrailsTitle',
		icon: mdiMapMarkerPath,
		module: 'MGA,courses',
		children: [
			{ title: 'academyCareerTrailsList', to: 'academy-career-trails-list' },
			{ title: 'academyCareerTrailsNew', to: 'academy-career-trails-new' },
			{ title: 'academyActivityTrailsTitle', to: 'academy-career-trails-activity' },
		],
	},
	{
		title: 'levelUpJobsMenuTitle',
		icon: mdiMapMarkerPath,
		module: 'MGA,courses',
		children: [
			{ title: 'levelUpJobsCareerQuestionsTitle', to: 'academy-level-up-jobs-career-questions' },
		],
	},
	{
		title: 'Mentores',
		icon: mdiAccountStar,
		children: [
			{ title: 'Mentores', to: 'academy-creators-list' },
			{ title: 'Candidaturas', to: 'academy-creator-applications-list' },
		],
	},
	{
		title: 'Mentorias',
		icon: mdiCalendarClock,
		children: [
			{ title: 'Ofertas', to: 'academy-mentorships-offers-list' },
			{ title: 'Sessões', to: 'academy-mentorships-sessions-list' },
			{ title: 'Bookings', to: 'academy-bookings-list' },
		],
	},
	{
		title: 'Acessos',
		icon: mdiKeyVariant,
		children: [
			{ title: 'Entitlements', to: 'academy-entitlements-list' },
			{ title: 'Concessão Manual', to: 'academy-entitlements-grant' },
		],
	},
	{
		title: 'Certificados',
		icon: mdiCertificate,
		children: [
			{ title: 'Templates', to: 'academy-certificate-templates-list' },
			{ title: 'Emitidos', to: 'academy-certificates-issued-list' },
		],
	},
	{
		title: 'Avaliações',
		icon: mdiStar,
		to: 'academy-reviews-moderation',
	},
	{
		title: 'Reports',
		icon: mdiFlag,
		children: [
			{ title: 'Fila', to: 'academy-reports-list' },
			{ title: 'Categorias', to: 'academy-report-categories-list' },
		],
	},
	{
		title: 'Promoções',
		icon: mdiTicketPercent,
		to: 'academy-promotions-list',
	},
	{
		title: 'Cupons de Mentores',
		icon: mdiTicketPercent,
		to: 'academy-coupons-list',
	},
	{
		title: 'Comissões',
		icon: mdiPercent,
		to: 'academy-commission-rules-list',
	},
	{
		title: 'Financeiro',
		icon: mdiCurrencyUsd,
		children: [
			{ title: 'Visão Geral',   to: 'academy-financial-overview' },
			{ title: 'Resgates',      to: 'academy-financial-payouts'  },
			{ title: 'Reembolsos',    to: 'academy-refund-requests'    },
		],
	},
	{
		title: 'Insights Salariais',
		icon: mdiChartLine,
		to: 'academy-insights-mappings',
	},
	{
		icon: mdiDomain,
		title: 'menu.institutions',
		to: 'institutions',
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'academy-messages-list',
		module: 'MGA,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'academy-newsletter-list',
		module: 'MGA,newsletter',
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGA,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'academy-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
]
